import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import url from '../../../helpers/url';
import mpx from '../../../actions/mpx_data';
import { safelyDecodeBase64 } from '../../../helpers/common';

export const useEpisodeList = (seasons) => {
    const [episodes, setEpisodes] = useState([]);

    const mutation = useMutation({
        mutationFn: async () => {
            if (!seasons.length) return;
            const encodedSeason = url.getQuery('season');
            const seasonNumber = encodedSeason ? safelyDecodeBase64(encodedSeason) : null;
            const selectedSeason = seasonNumber
                ? seasons.find((season) => season.tvSeasonNumber == seasonNumber || season.seasonNumber == seasonNumber)
                : null;

            const seasonID = selectedSeason?.Id || seasons[0].Id;
            const episodesList = await mpx.getEpisodes(seasonID);
            setEpisodes(episodesList);
            return { episodesList };
        },
    });

    useEffect(() => {
        mutation.mutate();
    }, []);

    return {
        mutation,
        episodes,
        setEpisodes,
    };
};
